import {Strings} from "@app/constants/strings";
import {Button, TextField, Typography} from "@mui/material";
import {FlexBox} from "@contents/components/customStyledComponent";
import ModalComp from "@contents/components/ModalComp";
import React, {ChangeEvent, useState} from "react";
import {isEmptyString} from "@utils/commonUtils";
import {AccessCertifyPageViewModel} from "@contents/viewModels/pages/accessCertifyPageViewModel";


type MemberCertifyAccessModalCompProps = {
    open: boolean
    handleClose: () => void
    handleSuccess: () => void
}

const MemberCertifyAccessModalComp = ({open, handleClose, handleSuccess}: MemberCertifyAccessModalCompProps) => {
    const {onMemberCertifyAccess, isMaster, onMemberCertifyAccessWithUser} = AccessCertifyPageViewModel();
    // const [reason, setReason] = useState<string>('');
    const [pwd, setPwd] = useState<string>('');
    // const [reasonError, setReasonError] = useState<boolean>(false);
    // const [reasonErrorMsg, setReasonErrorMsg] = useState<string>('');

    const [pwdError, setPwdError] = useState<boolean>(false);
    const [pwdErrorMsg, setPwdErrorMsg] = useState<string>('');


    const handleModalClose = () => {
        handleClose && handleClose()
    }

    // const handleReasonChange = (e: ChangeEvent<HTMLInputElement>) => {
    //     setReason(e.target.value);
    //     setReasonError(false);
    // }

    const handlePwdChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPwd(e.target.value);
        setPwdError(false);
    }

    // 접근 인증
    const handleCertifyAccess = () => {
        if (isEmptyString(pwd)) {
            setPwdErrorMsg(Strings.desc.plzEnterPassword)
            setPwdError(true);
            return;
        }

        // if (!isMinLength(reason, 3)) {
        //     setReasonErrorMsg(Strings.alert.minLengthThree)
        //     setReasonError(true);
        //     return;
        // }
        //
        // setReasonErrorMsg('')
        // setReasonError(false);

        if (isMaster()) {
            onMemberCertifyAccessWithUser({
                userPwd: pwd,
                callback: () => handleSuccess()
            })
        } else {
            onMemberCertifyAccess({
                userPwd: pwd,
                callback: () => handleSuccess()
            });
        }
    }

    // 취소
    const handleCancel = () => {
        handleModalClose();
        window.location.href = '/';
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            handleCertifyAccess();
        }
    }

    return (
        <ModalComp open={open}
                   title={Strings.privacyAccess}
                   onClose={handleClose}
                   maxWidth='sm'
                   sx={{zIndex: 10000}}
                   buttonComponent={
                       <>
                           <Button variant={'contained'} color={'eliga_FFF'}
                                   onClick={handleCancel}>{Strings.cancel}</Button>
                           <Button variant={'contained'} color={'eliga_2EC'}
                                   onClick={handleCertifyAccess}>{Strings.doCertification}</Button>
                       </>
                   }
                   disableBackdropClick={true}
                   disableEscapeKeyDown={true}
        >
            <FlexBox $column gap={'15px'}>
                <FlexBox $fullWidth $column gap={'5px'}>
                    <FlexBox $fullWidth $row alignItems={'center'}>
                        <Typography style={{minWidth: 80, flexShrink: 0}}>
                            {Strings.password}
                        </Typography>
                        <TextField
                            type={'password'}
                            fullWidth
                            placeholder={Strings.desc.plzEnterPassword}
                            value={pwd}
                            onChange={handlePwdChange}
                            variant={'standard'}
                            onKeyDown={(e) => handleKeyDown(e)}
                        />
                    </FlexBox>
                    <FlexBox>
                        {pwdError &&
                            <Typography variant={'caption'} color={'eliga_B5B.main'}>{pwdErrorMsg}</Typography>}
                    </FlexBox>
                </FlexBox>
                {/*<FlexBox $fullWidth $column gap={'5px'}>*/}
                {/*    <FlexBox $fullWidth $row alignItems={'center'}>*/}
                {/*        <Typography style={{minWidth: 80, flexShrink: 0}}>*/}
                {/*            {Strings.reasonContent}*/}
                {/*        </Typography>*/}
                {/*        <TextField*/}
                {/*            type={'text'}*/}
                {/*            fullWidth*/}
                {/*            placeholder={Strings.desc.plzWriteReason}*/}
                {/*            value={reason}*/}
                {/*            onChange={handleReasonChange}*/}
                {/*            variant={'standard'}*/}
                {/*        />*/}
                {/*    </FlexBox>*/}
                {/*    <FlexBox>*/}
                {/*        {reasonError &&*/}
                {/*            <Typography variant={'caption'} color={'eliga_B5B.main'}>{reasonErrorMsg}</Typography>}*/}
                {/*    </FlexBox>*/}
                {/*</FlexBox>*/}
            </FlexBox>
        </ModalComp>
    )
}

export default MemberCertifyAccessModalComp;
